module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-event.b98b3d81.png";